function customSlider() {
    if (!document.querySelector('.testimonial-slider')) {
        return;
    };

    const slider = document.querySelector('.testimonial-slider');
    const slides = slider.querySelectorAll('.custom-slide');
    const slidesSm = slider.querySelectorAll('.custom-slide-sm');

    const sliderBtnNext = slider.querySelector('.testimonial-button-next');
    const sliderBtnPrev = slider.querySelector('.testimonial-button-prev');

    const testimonialContainer = slider.querySelector('.testimonial-container');
    const testimonials = testimonialContainer.querySelectorAll('.testimonial');
    const testimonialBgs = slider.querySelectorAll('.testimonial-slider-bg');
    const testimonialBgsMob = slider.querySelectorAll('.testimonial-slider-bg-mob');

    let activeSlideIndex = 0;
    let lastSlideIndex = slides.length - 1;

    initZindexes();

    if (window.innerWidth > 768) {
        handleContainerHeight();
    }

    handleHeightOnMobile();

    sliderBtnNext.addEventListener('click', function (event) {
        handleImages(1, sliderBtnNext);
        handleText(1);
    });

    sliderBtnPrev.addEventListener('click', function (btn) {
        handleImages(-1, sliderBtnPrev);
        handleText(-1);
    });

    function handleImages(direction, btn) {
        let lastSlide = slider.querySelector('.custom-slide.last');
        let activeSlide = slider.querySelector('.custom-slide.active');
        let activeSlideSm = slider.querySelector('.custom-slide-sm.active');

        if (direction > 0) {
            activeSlideIndex = activeSlideIndex < slides.length - 1 ? activeSlideIndex + 1 : 0;
            lastSlideIndex = lastSlideIndex < slides.length - 1 ? lastSlideIndex + 1 : 0;

        } else {
            activeSlideIndex = activeSlideIndex > 0 ? activeSlideIndex - 1 : slides.length - 1;
            lastSlideIndex = lastSlideIndex > 0 ? lastSlideIndex - 1 : slides.length - 1;
        }

        handleBg(activeSlideIndex);
        handlePager(activeSlideIndex);

        lastSlide.classList.remove('last');
        activeSlide.classList.remove('active');

        slides[activeSlideIndex].classList.add('active');
        slides[lastSlideIndex].classList.add('last');

        if (activeSlideSm) {
            const smSlideIndex = activeSlideIndex === slides.length - 1 ? 0 : activeSlideIndex + 1;
            activeSlideSm.classList.remove('active');
            slidesSm[smSlideIndex].classList.add('active');
        }

        if (window.innerWidth > 768) {
            if (direction > 0) {
                animateActiveToLast(slides[lastSlideIndex]);
                animateTopToActive(slides[activeSlideIndex]);
            } else {
                animateLastToActive(lastSlide);
                animateActiveToTop(activeSlide);
                animateTopToLast(slides[lastSlideIndex]);
            }
        }

        if (direction > 0) {
            handleZindexes(direction);
        }

        /* Disable button until animation finishes */
        btn.disabled = true;
        setTimeout(() => {
            btn.disabled = false;
            /* handleZindexes(direction); */

            if (direction < 0) {
                if (direction < 0) {
                    handleZindexes(direction);
                }
            } else {

            }

        }, 800);

    }

    const activeProperties = {
        scale: 1,
        left: 'calc(64.5% + 2px)',
        top: '0%',
    };

    const lastProperties = {
        scale: 0.5,
        left: '53.5%',
        top: '3%',
    };

    const topProperties = {
        scale: 0.47,
        left: '-2%',
        top: 0,
        transformOrigin: 'center top',
    };

    function animateActiveToLast(slide) {
        slide.animate(
            [
                activeProperties,
                lastProperties,
            ],
            {
                duration: 600,
                iterations: 1,
                easing: 'ease-in-out',
            },
        ).onfinish = () => {
            slide.animate(
                [
                    { opacity: 0 },
                    { opacity: 1 },
                ],
                {
                    duration: 200,
                    iterations: 1,
                },
            )
        };
    }

    function animateTopToActive(slide) {
        slide.animate(
            [
                topProperties,
                activeProperties,
            ],
            {
                duration: 600,
                iterations: 1,
                easing: 'ease-in-out',
            },
        )
    }

    function animateLastToActive(slide) {
        slide.animate(
            [
                lastProperties,
                activeProperties,
            ],
            {
                duration: 600,
                iterations: 1,
                easing: 'ease-in-out',
            },
        );
    }

    function animateActiveToTop(slide) {

        slide.animate(
            [
                activeProperties,
                topProperties,
            ],
            {
                duration: 500,
                iterations: 1,
                easing: 'ease-in-out',
            },
        ).onfinish = () => {
            //handleZindexes();
        };
    }

    function animateTopToLast(slide) {
        slide.animate(
            [
                topProperties,
                topProperties,
            ],
            {
                duration: 0,
                iterations: 1,
            },
        ).onfinish = () => {

        };
    }

    function initZindexes() {
        slides.forEach((slide, index) => {
            slide.style.zIndex = slides.length - index;
        });
    }

    function handleZindexes(direction) {
        let n = slides.length;

        if (direction > 0) {
            slides.forEach((slide, index) => {
                let newZIndex = parseInt(slide.style.zIndex) + 1;
                newZIndex = newZIndex > n ? 1 : newZIndex;
                slide.style.zIndex = newZIndex;
            });
        } else {
            slides.forEach((slide, index) => {
                let newZIndex = parseInt(slide.style.zIndex) - 1;
                newZIndex = newZIndex < 1 ? n : newZIndex;
                slide.style.zIndex = newZIndex;
            });
        }
    };

    function handleText(direction) {
        const activeTestimonial = testimonialContainer.querySelector('.testimonial.active');
        const nextTestimonial = direction > 0 ? activeTestimonial.nextElementSibling || testimonials[0] : activeTestimonial.previousElementSibling || testimonials[testimonials.length - 1];

        activeTestimonial.classList.remove('active');
        nextTestimonial.classList.add('active');

        handleHeightOnMobile();
    }

    function handleContainerHeight() {
        let tallestHeight = 0;
        testimonials.forEach((testimonial, index) => {
            if (testimonial.scrollHeight > tallestHeight) {
                tallestHeight = testimonial.scrollHeight;
            }
        });

        testimonialContainer.style.height = (tallestHeight + 64) + 'px';
    };

    function handleHeightOnMobile() {
        if (window.innerWidth < 768) {
            const activeTestimonial = testimonialContainer.querySelector('.testimonial.active');
            const prevHeight = testimonialContainer.style.height;
            testimonialContainer.animate(
                [
                    // keyframes
                    { height: prevHeight },
                    { height: activeTestimonial.scrollHeight + 64 + 'px' },
                ],
                {
                    // timing options
                    duration: 300,
                    iterations: 1,
                    direction: 'normal',
                    easing: 'ease-in-out',
                },
            ).onfinish = () => {
                testimonialContainer.style.height = activeTestimonial.scrollHeight + 64 + 'px';
            };
        }
    }

    function handleBg() {
        if (testimonialBgs.length > 0) {
            const activeBg = slider.querySelector('.testimonial-slider-bg.active');
            activeBg.classList.remove('active');
            testimonialBgs[activeSlideIndex].classList.add('active');
        }
        if (testimonialBgsMob.length > 0) {
            const activeBgMob = slider.querySelector('.testimonial-slider-bg-mob.active');
            activeBgMob.classList.remove('active');
            testimonialBgsMob[activeSlideIndex].classList.add('active');
        }
    }

    function handlePager() {
        const pager = slider.querySelector('.testimonial-slider-pager');
        const currentEl = pager.querySelector('.slider-control-current');
        const totalEl = pager.querySelector('.slider-control-total');

        if (currentEl) {
            currentEl.textContent = String(activeSlideIndex + 1).padStart(2, '0');
        }
        if (totalEl) {
            totalEl.textContent = String(slides.length).padStart(2, '0');
        }
    };

}

export default customSlider;